(function (cjs, an) {

var p; // shortcut to reference prototypes
var lib={};var ss={};var img={};
lib.ssMetadata = [
		{name:"welcome_atlas_1", frames: [[1045,1324,487,41],[1593,1204,377,118],[723,1247,320,83],[1171,1082,420,148],[1171,1232,346,90],[0,1270,320,83],[723,1082,446,163],[0,0,1920,1080],[451,1270,227,80],[1534,1324,234,70],[1593,1082,383,120],[0,1082,721,186],[322,1270,127,182],[1922,0,95,85],[1994,87,51,89],[1922,87,70,86],[1922,175,64,64],[1922,241,64,64],[1922,307,64,64],[1922,373,64,64],[1922,439,64,64],[1922,505,64,64],[1922,571,64,64],[1922,637,64,64],[1922,703,64,64],[1922,769,64,64],[1922,835,64,64],[1922,901,64,64]]}
];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.CachedBmp_6 = function() {
	this.initialize(ss["welcome_atlas_1"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_5 = function() {
	this.initialize(ss["welcome_atlas_1"]);
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_62 = function() {
	this.initialize(ss["welcome_atlas_1"]);
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_61 = function() {
	this.initialize(ss["welcome_atlas_1"]);
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_60 = function() {
	this.initialize(ss["welcome_atlas_1"]);
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.CachedBmp_59 = function() {
	this.initialize(ss["welcome_atlas_1"]);
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.baloon = function() {
	this.initialize(ss["welcome_atlas_1"]);
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.bgSky = function() {
	this.initialize(ss["welcome_atlas_1"]);
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.Bitmap1 = function() {
	this.initialize(ss["welcome_atlas_1"]);
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.brand_idea = function() {
	this.initialize(ss["welcome_atlas_1"]);
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.cloud2 = function() {
	this.initialize(ss["welcome_atlas_1"]);
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.logo_selfie = function() {
	this.initialize(ss["welcome_atlas_1"]);
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.plant1 = function() {
	this.initialize(ss["welcome_atlas_1"]);
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.plant2 = function() {
	this.initialize(ss["welcome_atlas_1"]);
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib.plant3 = function() {
	this.initialize(ss["welcome_atlas_1"]);
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib.plant4 = function() {
	this.initialize(ss["welcome_atlas_1"]);
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib.preloader_0 = function() {
	this.initialize(ss["welcome_atlas_1"]);
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib.preloader_1 = function() {
	this.initialize(ss["welcome_atlas_1"]);
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();



(lib.preloader_10 = function() {
	this.initialize(ss["welcome_atlas_1"]);
	this.gotoAndStop(18);
}).prototype = p = new cjs.Sprite();



(lib.preloader_11 = function() {
	this.initialize(ss["welcome_atlas_1"]);
	this.gotoAndStop(19);
}).prototype = p = new cjs.Sprite();



(lib.preloader_2 = function() {
	this.initialize(ss["welcome_atlas_1"]);
	this.gotoAndStop(20);
}).prototype = p = new cjs.Sprite();



(lib.preloader_3 = function() {
	this.initialize(ss["welcome_atlas_1"]);
	this.gotoAndStop(21);
}).prototype = p = new cjs.Sprite();



(lib.preloader_4 = function() {
	this.initialize(ss["welcome_atlas_1"]);
	this.gotoAndStop(22);
}).prototype = p = new cjs.Sprite();



(lib.preloader_5 = function() {
	this.initialize(ss["welcome_atlas_1"]);
	this.gotoAndStop(23);
}).prototype = p = new cjs.Sprite();



(lib.preloader_6 = function() {
	this.initialize(ss["welcome_atlas_1"]);
	this.gotoAndStop(24);
}).prototype = p = new cjs.Sprite();



(lib.preloader_7 = function() {
	this.initialize(ss["welcome_atlas_1"]);
	this.gotoAndStop(25);
}).prototype = p = new cjs.Sprite();



(lib.preloader_8 = function() {
	this.initialize(ss["welcome_atlas_1"]);
	this.gotoAndStop(26);
}).prototype = p = new cjs.Sprite();



(lib.preloader_9 = function() {
	this.initialize(ss["welcome_atlas_1"]);
	this.gotoAndStop(27);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.size_1920x1080 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// size
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(255,255,255,0)").s().p("EiV/BUYMAAAiovMEr/AAAMAAACovg");
	this.shape.setTransform(960,540);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.size_1920x1080, new cjs.Rectangle(0,0,1920,1080), null);


(lib.message = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// text
	this.occ_text = new cjs.Text("", "25px 'Pixel NES'");
	this.occ_text.name = "occ_text";
	this.occ_text.textAlign = "center";
	this.occ_text.lineHeight = 31;
	this.occ_text.lineWidth = 336;
	this.occ_text.parent = this;
	this.occ_text.setTransform(247.9,43.8);

	this.timeline.addTween(cjs.Tween.get(this.occ_text).wait(1));

	// balloon
	this.instance = new lib.baloon();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.message, new cjs.Rectangle(0,0,446,163), null);


(lib.Interpolação9 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FBDB71").s().p("AmSFFIAAgKIAKAAIAAgKIAKAAIAAgUIAKAAIAAgUIAKAAIAAgUIAKAAIAAgKIAKAAIAAgUIAKAAIAAgUIAKAAIAAgUIAKAAIAAgKIAKAAIAAgUIAKAAIAAgUIAKAAIAAgKIAKAAIAAgUIAKAAIAAgUIAKAAIAAgUIAKAAIAAgKIAKAAIAAgUIAKAAIAAgUIAKAAIAAgTIAKAAIAAgKIAKAAIAAgUIAKAAIAAgUIAKAAIAAgUIAKAAIAAgKIAKAAIAAgUIAKAAIAAgUIAKAAIAAgKIAKAAIAAgUIAKAAIAAgUIAKAAIAAgUIAKAAIAAgKIAKAAIAAgUIAKAAIAAgUIAKAAIAAgUIAKAAIAAgKIAKAAIAAgUIAKAAIAAgUIGzAEIguBWIgKAAIAAAUIgKAAIAAAKIgKAAIAAAUIgKAAIAAAUIgKAAIAAAUIgKAAIAAAKIgKAAIAAAUIgKAAIAAAUIgKAAIAAAKIgKAAIAAAUIgKAAIAAAUIgKAAIAAAUIgKAAIAAAKIgKAAIAAATIgKAAIAAAUIgKAAIAAAUIgKAAIAAAKIgKAAIAAAUIgKAAIAAAUIgKAAIAAAUIgKAAIAAAKIgKAAIAAAUIgKAAIAAAUIgKAAIAAAKIgKAAIAAAUIgKAAIAAAUIgKAAIAAAUIgKAAIAAAKIgKAAIAAAUIgKAAIAAAUIgKAAIAAAUIgKAAIAAAKIgKAAIAAAKg");
	this.shape.setTransform(36.8,15.15);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FBD767").s().p("AjCFFIAAgKIAKAAIAAgUIAKAAIAAgUIAKAAIAAgKIAKAAIAAgUIAKAAIAAgUIAKAAIAAgUIAKAAIAAgUIAKAAIAAgKIAKAAIAAgUIAKAAIAAgUIAKAAIAAgUIAKAAIAAgUIAKAAIAAgKIAKAAIAAgUIAKAAIAAgUIAKAAIAAgUIAKAAIAAgUIAKAAIAAgJIAKAAIAAgUIAJAAIAAgUIAKAAIAAgUIAKAAIAAgKIAKAAIAAgUIAKAAIAAgUIAKAAIAAgUIAKAAIAAgUIAKAAIAAgKIAKAAIAAgUIAKAAIAAgUIAKAAIAAgUIAKAAIAAgUIAKAAIAAgKIAKAAIAAgUIAKAAIAAgUIAKAAIAAgUIAKAAIAAgKIAeAAIAAAUIgKAAIAAAKIgKAAIAAAUIgKAAIAAAUIgKAAIAAAUIgKAAIAAAKIgKAAIAAAUIgKAAIAAAUIgKAAIAAAUIgKAAIAAAUIgKAAIAAAKIgKAAIAAAUIgKAAIAAAUIgKAAIAAAUIgKAAIAAAUIgKAAIAAAKIgKAAIAAAUIgKAAIAAAUIgKAAIAAATIgKAAIAAAUIgJAAIAAAKIgKAAIAAAUIgKAAIAAAUIgKAAIAAAUIgKAAIAAAKIgKAAIAAAUIgKAAIAAAUIgKAAIAAAUIgKAAIAAAUIgKAAIAAAKIgKAAIAAAUIgKAAIAAAUIgKAAIAAAUIgKAAIAAAUIgKAAIAAAKIgKAAIAAAUIgKAAIAAAKg");
	this.shape_1.setTransform(3,15.15);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-16.5,-17.3,93.6,65);


(lib.gif = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// gif
	this.instance = new lib.preloader_0();

	this.instance_1 = new lib.preloader_1();

	this.instance_2 = new lib.preloader_2();

	this.instance_3 = new lib.preloader_3();

	this.instance_4 = new lib.preloader_4();

	this.instance_5 = new lib.preloader_5();

	this.instance_6 = new lib.preloader_6();

	this.instance_7 = new lib.preloader_7();

	this.instance_8 = new lib.preloader_8();

	this.instance_9 = new lib.preloader_9();

	this.instance_10 = new lib.preloader_10();

	this.instance_11 = new lib.preloader_11();

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},10).to({state:[{t:this.instance_2}]},10).to({state:[{t:this.instance_3}]},10).to({state:[{t:this.instance_4}]},10).to({state:[{t:this.instance_5}]},10).to({state:[{t:this.instance_6}]},10).to({state:[{t:this.instance_7}]},10).to({state:[{t:this.instance_8}]},10).to({state:[{t:this.instance_9}]},10).to({state:[{t:this.instance_10}]},10).to({state:[{t:this.instance_11}]},10).wait(10));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,64,64);


(lib.text = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// text_mask (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("EgiXACmIAAlMMBEvAAAIAAFMg");
	mask.setTransform(220,16.65);

	// text
	this.occ_value = new cjs.Text("", "25px 'Pixel NES'", "#333333");
	this.occ_value.name = "occ_value";
	this.occ_value.textAlign = "center";
	this.occ_value.lineHeight = 29;
	this.occ_value.lineWidth = 436;
	this.occ_value.parent = this;
	this.occ_value.setTransform(220,2);

	var maskedShapeInstanceList = [this.occ_value];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.occ_value).wait(1));

	// size
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(255,255,255,0)").s().p("EgiXACmIAAlMMBEvAAAIAAFMg");
	this.shape.setTransform(220,16.65);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.text, new cjs.Rectangle(0,0,440,33.3), null);


(lib.caret = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// caret
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#74ACBC").ss(3,2,1).p("AAAiVIAAEr");
	this.shape.setTransform(0,15);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.caret, new cjs.Rectangle(-1.5,-1.5,3,33), null);


(lib.error_pseudo = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// error
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#F1AD13").s().p("EgjtAEsIAAg5Ig5AAIAAgyIg5AAIAAl5IA5AAIAAg5IA5AAIAAg6MBHaAAAIAAA6IA5AAIAAA5IA6AAIAAF5Ig6AAIAAAyIg5AAIAAA5gEgk/ACYIA5AAIAAA5IA6AAIAAA6MBGYAAAIAAg6IA6AAIAAg5IA5AAIAAkvIg5AAIAAg5Ig6AAIAAg6MhGYAAAIAAA6Ig6AAIAAA5Ig5AAg");
	this.shape.setTransform(240,30);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("EgjMAELIAAg6Ig5AAIAAg5Ig5AAIAAkvIA5AAIAAg5IA5AAIAAg6MBGYAAAIAAA6IA6AAIAAA5IA5AAIAAEvIg5AAIAAA5Ig6AAIAAA6g");
	this.shape_1.setTransform(239.975,30);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.error_pseudo, new cjs.Rectangle(0,0,480,60), null);


(lib.btn_acess = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#33CC00").ss(1,1,1).p("A36npMAv1AAAIAAPTMgv1AAAg");
	this.shape.setTransform(0,0.025);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#99745C").s().p("A36HqIAAvTMAv1AAAIAAPTg");
	this.shape_1.setTransform(0,0.025);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_1},{t:this.shape}]},3).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-154,-50,308.1,100.1);


(lib.Interpolação6 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#E3D9EC").s().p("A8CINIAAlyIG5AAIAAkIIKRAAIAAFXIHHAAIAAorIDlAAIAAjLIKmAAIAAESIByAAIAADBIFZAAIAAEjIKdAAIAAEjg");
	this.shape.setTransform(-9.25,39.25);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AavOVIAAkjIqeAAIAAkjIlYAAIAAjCIhzAAIAAkQIqmAAIAADJIjlAAIAAIsInHAAIAAlXIqQAAIAAEIIm5AAIAAFyItGAAIAAk1IGwAAIAAnTIKeAAIAAkiIMNAAIAADtIFTAAIAArAIGfAAIAAksIMhAAIAAJpIDuAAIAACOIKeAAIAAEHIEjAAIAAHcIMaAAIAAFPg");
	this.shape_1.setTransform(-0.875,0);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-272.5,-91.7,543.3,183.4);


(lib.Interpolação4 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.instance = new lib.cloud2();
	this.instance.setTransform(-191.5,-60);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-191.5,-60,383,120);


(lib.Interpolação3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.instance = new lib.cloud2();
	this.instance.setTransform(-191.5,-60);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-191.5,-60,383,120);


(lib.Interpolação1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AdnMiIAAi5ImnAAIAAiwIphAAIAACwIieAAIAAj/Io1AAIAAqeIo8AAIAAGeIk9AAIAABGIpYAAIAAFYIjUAAIAABhImMAAIAAC5Il8AAIAAk0IIRAAIAAhYICfAAIAAlYIFhAAIAAjlIIaAAIAAhyIB7AAIAAoIILbAAIAAEIIE1AAIAAA1IBPAAIAAIQIDuAAIAAi4IKnAAIAAEiIIRAAIAAFYIGEAAIAAARIAUAAIAAEjg");
	this.shape.setTransform(-0.775,0.925);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#E4D9ED").s().p("A+GIsIAAi6IGNAAIAAhhIDTAAIAAlXIJYAAIAAhGIE+AAIAAmfII8AAIAAKeII0AAIAAD/ICfAAIAAiwIJgAAIAACwIGoAAIAAC6g");
	this.shape_1.setTransform(-3.925,25.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-234.5,-79.3,467.5,160.5);


(lib.brand = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.instance = new lib.logo_selfie();
	this.instance.setTransform(-360.5,-93);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.brand, new cjs.Rectangle(-360.5,-93,721,186), null);


(lib.animaPlant2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.instance = new lib.plant2();
	this.instance.setTransform(-47.5,-42.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.animaPlant2, new cjs.Rectangle(-47.5,-42.5,95,85), null);


(lib.anima_plant4 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.instance = new lib.plant4();
	this.instance.setTransform(-35,-43);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.anima_plant4, new cjs.Rectangle(-35,-43,70,86), null);


(lib.anima_plant3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.instance = new lib.plant3();
	this.instance.setTransform(-25.5,-44.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.anima_plant3, new cjs.Rectangle(-25.5,-44.5,51,89), null);


(lib.anima_Plant1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.instance = new lib.plant1();
	this.instance.setTransform(-63.5,-91);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.anima_Plant1, new cjs.Rectangle(-63.5,-91,127,182), null);


(lib.preload = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// gif
	this.instance = new lib.gif();
	this.instance.setTransform(928,508);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// backgound
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(0,0,0,0.298)").s().p("EgjoAmkMAAAhNHMBHRAAAMAAABNHg");
	this.shape.setTransform(960.0079,540.0076,4.2091,2.1882);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.preload, new cjs.Rectangle(0,0,1920,1080), null);


(lib.animate_caret = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// caret
	this.instance = new lib.caret();
	this.instance.alpha = 0;

	this.timeline.addTween(cjs.Tween.get(this.instance).to({alpha:1},14).wait(1).to({alpha:0},14).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2,-2,4,34);


(lib.input_text_02 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// animate_caret
	this.occ_caret = new lib.animate_caret();
	this.occ_caret.name = "occ_caret";
	this.occ_caret.setTransform(240,15);
	this.occ_caret.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_caret).wait(1));

	// text
	this.occ_text = new lib.text();
	this.occ_text.name = "occ_text";
	this.occ_text.setTransform(20,13.35);

	this.timeline.addTween(cjs.Tween.get(this.occ_text).wait(1));

	// placeholder
	this.occ_placeholder = new cjs.Text("SENHA", "25px 'Pixel NES'", "#AABBC0");
	this.occ_placeholder.name = "occ_placeholder";
	this.occ_placeholder.textAlign = "center";
	this.occ_placeholder.lineHeight = 29;
	this.occ_placeholder.parent = this;
	this.occ_placeholder.setTransform(240,15.35);

	this.timeline.addTween(cjs.Tween.get(this.occ_placeholder).wait(1));

	// error_text
	this.occ_error = new cjs.Text("", "16px 'Pixel NES'");
	this.occ_error.name = "occ_error";
	this.occ_error.textAlign = "center";
	this.occ_error.lineHeight = 21;
	this.occ_error.lineWidth = 476;
	this.occ_error.parent = this;
	this.occ_error.setTransform(240,62);

	this.timeline.addTween(cjs.Tween.get(this.occ_error).wait(1));

	// error_pseudo
	this.occ_pseudo = new lib.error_pseudo();
	this.occ_pseudo.name = "occ_pseudo";
	this.occ_pseudo.setTransform(240,30,1,1,0,0,0,240,30);
	this.occ_pseudo.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_pseudo).wait(1));

	// input
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("EgjMAELIAAg6Ig5AAIAAg5Ig5AAIAAkvIA5AAIAAg5IA5AAIAAg6MBGYAAAIAAA6IA6AAIAAA5IA5AAIAAEvIg5AAIAAA5Ig6AAIAAA6g");
	this.shape.setTransform(239.975,30);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#040300").s().p("EgjtAEsIAAg5Ig5AAIAAgyIg5AAIAAl5IA5AAIAAg5IA5AAIAAg6MBHaAAAIAAA6IA5AAIAAA5IA6AAIAAF5Ig6AAIAAAyIg5AAIAAA5gEgk/ACYIA5AAIAAA5IA6AAIAAA6MBGYAAAIAAg6IA6AAIAAg5IA5AAIAAkvIg5AAIAAg5Ig6AAIAAg6MhGYAAAIAAA6Ig6AAIAAA5Ig5AAg");
	this.shape_1.setTransform(240,30);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.input_text_02, new cjs.Rectangle(0,0,480,82.8), null);


(lib.input_text_01 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// animate_caret
	this.occ_caret = new lib.animate_caret();
	this.occ_caret.name = "occ_caret";
	this.occ_caret.setTransform(240,15);
	this.occ_caret.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_caret).wait(1));

	// text
	this.occ_text = new lib.text();
	this.occ_text.name = "occ_text";
	this.occ_text.setTransform(20,13.35);

	this.timeline.addTween(cjs.Tween.get(this.occ_text).wait(1));

	// placeholder
	this.occ_placeholder = new cjs.Text("Matrícula", "25px 'Pixel NES'", "#AABBC0");
	this.occ_placeholder.name = "occ_placeholder";
	this.occ_placeholder.textAlign = "center";
	this.occ_placeholder.lineHeight = 29;
	this.occ_placeholder.parent = this;
	this.occ_placeholder.setTransform(240,15.35);

	this.timeline.addTween(cjs.Tween.get(this.occ_placeholder).wait(1));

	// error_text
	this.occ_error = new cjs.Text("", "16px 'Pixel NES'");
	this.occ_error.name = "occ_error";
	this.occ_error.textAlign = "center";
	this.occ_error.lineHeight = 21;
	this.occ_error.lineWidth = 476;
	this.occ_error.parent = this;
	this.occ_error.setTransform(240,62);

	this.timeline.addTween(cjs.Tween.get(this.occ_error).wait(1));

	// error_pseudo
	this.occ_pseudo = new lib.error_pseudo();
	this.occ_pseudo.name = "occ_pseudo";
	this.occ_pseudo.setTransform(240,30,1,1,0,0,0,240,30);
	this.occ_pseudo.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_pseudo).wait(1));

	// input
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#040300").s().p("EgjtAEsIAAg5Ig5AAIAAgyIg5AAIAAl5IA5AAIAAg5IA5AAIAAg6MBHaAAAIAAA6IA5AAIAAA5IA6AAIAAF5Ig6AAIAAAyIg5AAIAAA5gEgk/ACYIA5AAIAAA5IA6AAIAAA6MBGYAAAIAAg6IA6AAIAAg5IA5AAIAAkvIg5AAIAAg5Ig6AAIAAg6MhGYAAAIAAA6Ig6AAIAAA5Ig5AAg");
	this.shape.setTransform(240,30);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("EgjMAELIAAg6Ig5AAIAAg5Ig5AAIAAkvIA5AAIAAg5IA5AAIAAg6MBGYAAAIAAA6IA6AAIAAA5IA5AAIAAEvIg5AAIAAA5Ig6AAIAAA6g");
	this.shape_1.setTransform(239.975,30);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.input_text_01, new cjs.Rectangle(0,0,480,82.8), null);


(lib.form = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// input_text_01
	this.auth_registration = new lib.input_text_01();
	this.auth_registration.name = "auth_registration";
	this.auth_registration.setTransform(0,-85.85);

	this.timeline.addTween(cjs.Tween.get(this.auth_registration).wait(1));

	// input_text_02
	this.auth_password = new lib.input_text_02();
	this.auth_password.name = "auth_password";

	this.timeline.addTween(cjs.Tween.get(this.auth_password).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.form, new cjs.Rectangle(0,-85.8,480,168.6), null);


(lib.plant4_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.instance = new lib.anima_plant4();

	this.timeline.addTween(cjs.Tween.get(this.instance).to({scaleY:1.3193,skewX:14.3918},25).to({scaleY:1,skewX:0},28).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-49.1,-54.9,98.2,109.9);


(lib.plant3_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.instance = new lib.anima_plant3();

	this.timeline.addTween(cjs.Tween.get(this.instance).to({scaleX:0.8775,scaleY:0.9601,skewX:23.9317},31).to({scaleX:1,scaleY:1,skewX:0},29).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-39.7,-44.5,79.5,89);


(lib.plant2_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.instance = new lib.animaPlant2();

	this.timeline.addTween(cjs.Tween.get(this.instance).to({scaleX:0.6736,scaleY:0.9925,skewX:21.6259,skewY:3.5182},24).to({scaleX:1,scaleY:1,skewX:0,skewY:0},23).to({scaleY:1.0207,skewX:-11.5693},20).to({scaleY:1,skewX:0},17).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-56.2,-42.9,112.4,85.9);


(lib.plant1_2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.instance = new lib.anima_Plant1();
	this.instance.setTransform(0,66,0.2299,0.2299);
	this.instance._off = true;
	var instanceFilter_1 = new cjs.ColorFilter(1,1,1,1,0,0,0,0);
	this.instance.filters = [instanceFilter_1];
	this.instance.cache(-65,-93,131,186);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(93).to({_off:false},0).to({scaleX:1,scaleY:1,y:0},44).to({scaleX:1.1907,scaleY:1.1907},25).to({scaleX:1,scaleY:1},20).to({scaleX:1.1907,scaleY:1.1907},20).to({scaleX:1,scaleY:1},30).wait(40).to({scaleX:1.1428,scaleY:1.1428},30).to({scaleX:1,scaleY:1},30).to({scaleX:1.1912,scaleY:1.1912},30).to({scaleX:1,scaleY:1},15).wait(15).to({scaleX:0.2299,scaleY:0.2299,y:66},78).wait(1));
	this.timeline.addTween(cjs.Tween.get(instanceFilter_1).wait(93).to(new cjs.ColorFilter(1,1,1,1,0,0,0,0), 44).wait(135).to(new cjs.ColorFilter(1,1,1,1,0,0,0,0), 30).wait(90).to(new cjs.ColorFilter(0.14,0.14,0.14,1,87.72,87.72,87.72,0), 78).wait(1));

	this.filterCacheList = [];
	this.filterCacheList.push({instance: this.instance, startFrame:93, endFrame:93, x:-65, y:-93, w:131, h:186});
	this.filterCacheList.push({instance: this.instance, startFrame:94, endFrame:137, x:-65, y:-93, w:131, h:186});
	this.filterCacheList.push({instance: this.instance, startFrame:272, endFrame:272, x:-65, y:-93, w:131, h:186});
	this.filterCacheList.push({instance: this.instance, startFrame:273, endFrame:302, x:-65, y:-93, w:131, h:186});
	this.filterCacheList.push({instance: this.instance, startFrame:392, endFrame:392, x:-65, y:-93, w:131, h:186});
	this.filterCacheList.push({instance: this.instance, startFrame:393, endFrame:470, x:-65, y:-93, w:131, h:186});
	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-75.6,-108.4,151.3,216.8);


(lib.plant1_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.instance = new lib.anima_Plant1();
	this.instance.setTransform(0,66,0.2299,0.2299);
	var instanceFilter_1 = new cjs.ColorFilter(1,1,1,1,0,0,0,0);
	this.instance.filters = [instanceFilter_1];
	this.instance.cache(-65,-93,131,186);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({scaleX:1,scaleY:1,y:0},46).to({scaleX:1.1907,scaleY:1.1907},25).to({scaleX:1,scaleY:1},20).to({scaleX:1.1907,scaleY:1.1907},20).to({scaleX:1,scaleY:1},30).wait(40).to({scaleX:1.1428,scaleY:1.1428},30).to({scaleX:1,scaleY:1},30).to({scaleX:1.1912,scaleY:1.1912},30).to({scaleX:1,scaleY:1},15).wait(15).to({scaleX:0.2299,scaleY:0.2299,y:66},78).wait(61));
	this.timeline.addTween(cjs.Tween.get(instanceFilter_1).wait(181).to(new cjs.ColorFilter(1,1,1,1,0,0,0,0), 30).wait(90).to(new cjs.ColorFilter(0.14,0.14,0.14,1,87.72,87.72,87.72,0), 78).wait(1).to(new cjs.ColorFilter(1,1,1,1,0,0,0,0), 0).wait(60));

	this.filterCacheList = [];
	this.filterCacheList.push({instance: this.instance, startFrame:181, endFrame:181, x:-65, y:-93, w:131, h:186});
	this.filterCacheList.push({instance: this.instance, startFrame:182, endFrame:211, x:-65, y:-93, w:131, h:186});
	this.filterCacheList.push({instance: this.instance, startFrame:301, endFrame:301, x:-65, y:-93, w:131, h:186});
	this.filterCacheList.push({instance: this.instance, startFrame:302, endFrame:379, x:-65, y:-93, w:131, h:186});
	this.filterCacheList.push({instance: this.instance, startFrame:380, endFrame:380, x:-65, y:-93, w:131, h:186});
	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-75.6,-108.4,151.3,216.8);


(lib.cloud3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.instance = new lib.Interpolação1("synched",0);
	this.instance.setTransform(233,82);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({x:2860},299).to({_off:true},1).wait(100));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1.5,0,3094.5,163.2);


(lib.cloud2_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.instance = new lib.cloud2();

	this.instance_1 = new lib.Interpolação3("synched",0);
	this.instance_1.setTransform(191.5,60);
	this.instance_1._off = true;

	this.instance_2 = new lib.Interpolação4("synched",0);
	this.instance_2.setTransform(2731.5,60);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},54).to({state:[{t:this.instance_2}]},300).to({state:[]},1).wait(70));
	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(54).to({_off:false},0).to({_off:true,x:2731.5},300).wait(71));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,2923,120);


(lib.cloud1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.instance = new lib.Interpolação6("synched",0);
	this.instance.setTransform(272.5,95.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(204).to({startPosition:0},0).to({x:3202.5},330).to({_off:true},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,3473.3,187.2);


(lib.brand_selfie = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.instance = new lib.brand();
	this.instance.setTransform(360.5,93);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({y:61.05},49).to({y:93},50).to({y:114.3},50).to({y:93},45).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,-31.9,721,239.20000000000002);


(lib.anima_clouds = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("EiV/BUYMAAAiovMEr/AAAMAAACovg");
	mask.setTransform(960,540);

	// Camada_1
	this.instance = new lib.cloud3();
	this.instance.setTransform(-239,606.6,1,1,0,0,0,233,82);

	this.instance_1 = new lib.cloud2_1();
	this.instance_1.setTransform(-378.15,131,1,1,0,0,0,191.5,60);

	this.instance_2 = new lib.cloud1();
	this.instance_2.setTransform(-686,418.7,1,1,0,0,0,272.5,95.5);

	var maskedShapeInstanceList = [this.instance,this.instance_1,this.instance_2];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.anima_clouds, new cjs.Rectangle(0,0,0,0), null);


(lib.anima_button = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_3 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	var mask_graphics_0 = new cjs.Graphics().p("AtlFFIAAg8IgKAAIAAgKIg8AAIAAg8IhGAAIAAl7IBGAAIAAhGIBGAAIAAhGIbLAAIAABGIBGAAIAABGIBGAAIAAF7IhGAAIAAA8Ig8AAIAAAKIgKAAIAAA8g");

	this.timeline.addTween(cjs.Tween.get(mask).to({graphics:mask_graphics_0,x:0,y:-0.5}).wait(45).to({graphics:null,x:0,y:0}).wait(45));

	// Camada_2
	this.instance = new lib.Interpolação9("synched",0);
	this.instance.setTransform(-179.7,-15.45);

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).to({x:143.3,y:-15.05},44).to({_off:true},1).wait(45));

	// Camada_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#685927").s().p("AjWAFIAAgJIGtAAIAAAJg");
	this.shape.setTransform(32.5,32.5);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#258199").s().p("AuNAFIAAgJIcbAAIAAAJg");
	this.shape_1.setTransform(0,36.5);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#1E6A7F").s().p("AOOAjIAAhFIBGAAIAAAKIg8AAIAAA7gAuXAjIAAg7Ig8AAIAAgKIBGAAIAABFg");
	this.shape_2.setTransform(0,32.5);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#4D3100").s().p("AIcAFIAAgJIFKAAIAAAJgAtlAFIAAgJINSAAIAAAJg");
	this.shape_3.setTransform(0,32.5);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#533A08").s().p("AhAAFIAAgJICBAAIAAAJg");
	this.shape_4.setTransform(4.5,32.5);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#FEAF00").s().p("AjqEiIAAgKIAKAAIAAgKIAKAAIAAgUIAKAAIAAgUIAKAAIAAgUIAKAAIAAgKIAKAAIAAgUIAKAAIAAgUIAKAAIAAgUIAKAAIAAgKIAKAAIAAgUIAKAAIAAgUIAKAAIAAgKIAKAAIAAgUIAKAAIAAgUIAKAAIAAgUIAKAAIAAgKIAKAAIAAgTIAKAAIAAgUIAKAAIAAgUIAKAAIAAgKIAKAAIAAgUIAKAAIAAgUIAKAAIAAgUIAJAAIAAgKIAKAAIAAgUIAKAAIAAgUIAKAAIAAgKIAKAAIAAgUIAKAAIAAgUIAKAAIAAgUIAKAAIAAgKIAKAAIAAgUIAKAAIAAgUIBGAAIAABGIBGAAIAAF7IhGAAIAAA8Ig8AAIAAAKIgKAAIAAA8g");
	this.shape_5.setTransform(77.5,3);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#040300").s().p("AuNFtIAAhGIhGAAIAAg8IhGAAIAAnLIBGAAIAAhGIBGAAIAAhGIcbAAIAABGIBGAAIAABGIBGAAIAAHLIhGAAIAAA8IhGAAIAABGgAvxDDIBGAAIAAA8IA8AAIAAAKIAKAAIAAA8IAAAKINSAAICBAAIGuAAIFKAAIAAgKIAAg8IAKAAIAAgKIA8AAIAAg8IBGAAIAAl7IhGAAIAAhGIhGAAIAAhGI7LAAIAABGIhGAAIAABGIhGAAg");
	this.shape_6.setTransform(0,-0.5);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#FEB000").s().p("AC0FFIiCAAItRAAIAAg8IgKAAIAAgKIg8AAIAAg8IhGAAIAAl7IBGAAIAAhGIBGAAIAAhGIbLAAIAABGIAAAUIgKAAIAAAUIgKAAIAAAKIgKAAIAAAUIgKAAIAAAUIgKAAIAAAUIgKAAIAAAKIgKAAIAAAUIgKAAIAAAUIgKAAIAAAKIgKAAIAAAUIgKAAIAAAUIgKAAIAAAUIgKAAIAAAKIgKAAIAAATIgKAAIAAAUIgKAAIAAAUIgKAAIAAAKIgKAAIAAAUIgKAAIAAAUIgKAAIAAAUIgKAAIAAAKIgKAAIAAAUIgKAAIAAAUIgKAAIAAAKIgKAAIAAAUIgKAAIAAAUIgKAAIAAAUIgKAAIAAAKIgKAAIAAAUIgKAAIAAAUIgKAAIAAAUIgKAAIAAAKIgKAAIAAAKg");
	this.shape_7.setTransform(-7,-0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_7},{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(90));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-105,-37,210,74);


(lib.btn_enter = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_1
	this.instance = new lib.CachedBmp_59();
	this.instance.setTransform(-80,-21.5,0.5,0.5);

	this.instance_1 = new lib.anima_button();

	this.instance_2 = new lib.CachedBmp_60();
	this.instance_2.setTransform(-86.35,-23.2,0.5,0.5);

	this.instance_3 = new lib.Bitmap1();
	this.instance_3.setTransform(-113,-40);

	this.instance_4 = new lib.CachedBmp_62();
	this.instance_4.setTransform(-80,-21.5,0.5,0.5);

	this.instance_5 = new lib.CachedBmp_61();
	this.instance_5.setTransform(-105,-37,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).to({state:[{t:this.instance_3},{t:this.instance_2}]},1).to({state:[{t:this.instance_5},{t:this.instance_4}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-196.2,-40,310.2,80);


(lib.Plants = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("EiV/AMEIAA4HMEr/AAAIAAYHg");
	mask.setTransform(629.65,-33.6);

	// Camada_1
	this.instance = new lib.plant4_1();
	this.instance.setTransform(610,27);

	this.instance_1 = new lib.plant2_1();
	this.instance_1.setTransform(1461,22.85,1,1,0,0,180);

	this.instance_2 = new lib.plant3_1();
	this.instance_2.setTransform(432.5,28.5);

	this.instance_3 = new lib.plant2_1();
	this.instance_3.setTransform(-194.5,31.5);

	this.instance_4 = new lib.plant1_2();
	this.instance_4.setTransform(1023.45,30.3,0.6652,0.6652,0,0,0,0.1,0.1);

	this.instance_5 = new lib.plant1_1();

	var maskedShapeInstanceList = [this.instance,this.instance_1,this.instance_2,this.instance_3,this.instance_4,this.instance_5];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));
	this.instance_4.addEventListener("tick", AdobeAn.handleFilterCache);
	this.instance_5.addEventListener("tick", AdobeAn.handleFilterCache);

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Plants, new cjs.Rectangle(-242,-19.6,1750.5,63.2), null);


(lib.content_frame_01 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// preload
	this.occ_preload = new lib.preload();
	this.occ_preload.name = "occ_preload";
	this.occ_preload.setTransform(960,540,1,1,0,0,0,960,540);
	this.occ_preload.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_preload).wait(1));

	// form
	this.occ_form = new lib.form();
	this.occ_form.name = "occ_form";
	this.occ_form.setTransform(960,571.05,1,1,0,0,0,240,30);

	this.timeline.addTween(cjs.Tween.get(this.occ_form).wait(1));

	// message
	this.occ_message = new lib.message();
	this.occ_message.name = "occ_message";
	this.occ_message.setTransform(1430.15,679.45,1,1,0,0,0,223,81.5);
	this.occ_message.visible = false;

	this.timeline.addTween(cjs.Tween.get(this.occ_message).wait(1));

	// buttons
	this.btn_recovery = new lib.btn_acess();
	this.btn_recovery.name = "btn_recovery";
	this.btn_recovery.setTransform(954.5,740.2,1,0.5303);
	new cjs.ButtonHelper(this.btn_recovery, 0, 1, 2, false, new lib.btn_acess(), 3);

	this.btn_submit = new lib.btn_enter();
	this.btn_submit.name = "btn_submit";
	this.btn_submit.setTransform(960.75,670.6);
	new cjs.ButtonHelper(this.btn_submit, 0, 1, 2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.btn_submit},{t:this.btn_recovery}]}).wait(1));

	// tipology
	this.instance = new lib.CachedBmp_6();
	this.instance.setTransform(838.35,719.85,0.5,0.5);

	this.instance_1 = new lib.CachedBmp_5();
	this.instance_1.setTransform(865.7,376.3,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

	// brands
	this.instance_2 = new lib.brand_idea();
	this.instance_2.setTransform(843,780);

	this.instance_3 = new lib.brand_selfie();
	this.instance_3.setTransform(960,230.9,1,1,0,0,0,360.5,93);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_3},{t:this.instance_2}]}).wait(1));

	// clouds
	this.instance_4 = new lib.anima_clouds();
	this.instance_4.setTransform(476.2,304.5,1,1,0,0,0,476.2,304.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(1));

	// plants
	this.instance_5 = new lib.Plants();
	this.instance_5.setTransform(331.5,885);

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(1));

	// background
	this.instance_6 = new lib.bgSky();

	this.timeline.addTween(cjs.Tween.get(this.instance_6).wait(1));

	// size
	this.instance_7 = new lib.size_1920x1080();

	this.timeline.addTween(cjs.Tween.get(this.instance_7).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.content_frame_01, new cjs.Rectangle(-958.5,0,2879.7,1080), null);


// stage content:
(lib.welcome = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {frame01:1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.actionFrames = [0,1];
	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		/**
		 *
		 * Class reference.
		 */
		StageClass.auth.scene.layerActions.frame01Login(this, 'welcome');
	}
	this.frame_1 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1));

	// ContentFrame
	this.occ_frame_01 = new lib.content_frame_01();
	this.occ_frame_01.name = "occ_frame_01";
	this.occ_frame_01._off = true;

	this.timeline.addTween(cjs.Tween.get(this.occ_frame_01).wait(1).to({_off:false},0).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,1921.2,1080);
// library properties:
lib.properties = {
	id: '9FFA7194C2EBEF4EBA834F40B6902570',
	width: 1920,
	height: 1080,
	fps: 60,
	color: "#FFFFFF",
	opacity: 0.00,
	manifest: [
		{src:"welcome/welcome_atlas_1.png", id:"welcome_atlas_1"}
	],
	preloads: []
};



// bootstrap callback support:

(lib.Stage = function(canvas) {
	createjs.Stage.call(this, canvas);
}).prototype = p = new createjs.Stage();

p.setAutoPlay = function(autoPlay) {
	this.tickEnabled = autoPlay;
}
p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
p.stop = function(ms) { if(ms) this.seek(ms); this.tickEnabled = false; }
p.seek = function(ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }

p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }

an.bootcompsLoaded = an.bootcompsLoaded || [];
if(!an.bootstrapListeners) {
	an.bootstrapListeners=[];
}

an.bootstrapCallback=function(fnCallback) {
	an.bootstrapListeners.push(fnCallback);
	if(an.bootcompsLoaded.length > 0) {
		for(var i=0; i<an.bootcompsLoaded.length; ++i) {
			fnCallback(an.bootcompsLoaded[i]);
		}
	}
};

an.compositions = an.compositions || {};
an.compositions['9FFA7194C2EBEF4EBA834F40B6902570'] = {
	getStage: function() { return exportRoot.stage; },
	getLibrary: function() { return lib; },
	getSpriteSheet: function() { return ss; },
	getImages: function() { return img; }
};

an.compositionLoaded = function(id) {
	an.bootcompsLoaded.push(id);
	for(var j=0; j<an.bootstrapListeners.length; j++) {
		an.bootstrapListeners[j](id);
	}
}

an.getComposition = function(id) {
	return an.compositions[id];
}


an.makeResponsive = function(isResp, respDim, isScale, scaleType, domContainers) {		
	var lastW, lastH, lastS=1;		
	window.addEventListener('resize', resizeCanvas);		
	resizeCanvas();		
	function resizeCanvas() {			
		var w = lib.properties.width, h = lib.properties.height;			
		var iw = document.documentElement.clientWidth, ih = document.documentElement.clientHeight;			
		var pRatio = window.devicePixelRatio || 1, xRatio=iw/w, yRatio=ih/h, sRatio=1;			
		if(isResp) {                
			if((respDim=='width'&&lastW==iw) || (respDim=='height'&&lastH==ih)) {                    
				sRatio = lastS;                
			}				
			else if(!isScale) {					
				if(iw<w || ih<h)						
					sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==1) {					
				sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==2) {					
				sRatio = Math.max(xRatio, yRatio);				
			}			
		}
		domContainers[0].width = w * pRatio * sRatio;			
		domContainers[0].height = h * pRatio * sRatio;
		domContainers.forEach(function(container) {				
			container.style.width = w * sRatio + 'px';				
			container.style.height = h * sRatio + 'px';			
		});
		stage.scaleX = pRatio*sRatio;			
		stage.scaleY = pRatio*sRatio;
		lastW = iw; lastH = ih; lastS = sRatio;            
		stage.tickOnUpdate = false;            
		stage.update();            
		stage.tickOnUpdate = true;		
	}
}
an.handleSoundStreamOnTick = function(event) {
	if(!event.paused){
		var stageChild = stage.getChildAt(0);
		if(!stageChild.paused || stageChild.ignorePause){
			stageChild.syncStreamSounds();
		}
	}
}
an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(createjs = createjs||{}, AdobeAn = AdobeAn||{});
